var _circle, _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.4997,
    r: 26.777,
    stroke: "#747E87",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5745 14.4863H27.2893V33.4458H30.5745V14.4863Z",
    fill: "#747E87"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.9123,
    cy: 39.6292,
    rx: 2.06081,
    ry: 2.06081,
    fill: "#747E87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoBig);
export default __webpack_public_path__ + "static/media/icon-info-big.454074a3db4d4f5e9d116fa988b91853.svg";
export { ForwardRef as ReactComponent };